/* eslint-disable react-hooks/exhaustive-deps */
import { Badge } from 'react-bootstrap';
import useDataTable from '../../../hooks/useDataTable';

export default function ShowTable({ data }) {
    // const conditionalCellStyles = [
    //     {
    //         when: (row) => Number(row.partner_available_qty) <= 0,
    //         style: {
    //             backgroundColor: '#ffb4c1',
    //         },
    //     },
    // ];

    const columns = [
        {
            name: 'Item Names',
            selector: (row) => row.drug_name,
            sortable: true,
            wrap: true,
            grow: 2,
            fixed: true,
            // conditionalCellStyles,
        },
        {
            name: 'Category Name',
            selector: (row) => row.category_name,
            sortable: true,
            // conditionalCellStyles,
        },
        {
            name: 'Status',
            sortable: true,
            // conditionalCellStyles,
            cell: (row) =>
                row.status === 'distributed' ? (
                    <Badge className="badgeActive" bg="success">
                        Distributed
                    </Badge>
                ) : row.status === 'forwarded' ? (
                    <Badge className="badgeActive" bg="success">
                        Forwarded
                    </Badge>
                ) : (
                    <Badge className="badgeInactive" bg="success">
                        Pending
                    </Badge>
                ),
        },
        {
            name: 'Facility Request Qty',
            selector: (row) => row.facility_approved_qty,
            sortable: true,
            // conditionalCellStyles,
        },
        {
            name: 'Availability in Partner Stock',
            selector: (row) => (row.partner_available_qty ? row.partner_available_qty : 0),
            sortable: true,
            // conditionalCellStyles,
        },
        {
            name: 'Partner Distributed Qty',
            selector: (row) => row.partner_distribute_qty,
            sortable: true,
            // conditionalCellStyles,
        },
        {
            name: 'Partner Distribute APV Qty',
            selector: (row) => row.partner_distribute_apv_qty,
            sortable: true,
            // conditionalCellStyles,
        },
        {
            name: 'Partner Forwarded Qty',
            selector: (row) => row.partner_forward_qty,
            sortable: true,
            // conditionalCellStyles,
        },
        {
            name: 'Partner Forward APV Qty',
            selector: (row) => row.partner_forward_apv_qty,
            sortable: true,
            // conditionalCellStyles,
        },
    ];

    const search_column = {
        // drug_name: 'Name',
    };
    return useDataTable({ columns, data, search_column, pagination: false });
}
